import Circle from "../../../../../src/entities/Circle";
import PointManager from "../PointManager";
import AngleManager from "../AngleManager";
import LineManager from "../LineManager";
import SliderManager from "../SliderManager";
import { runIntroAnimation } from "./IntroAnimationSequence";
import CalculationLine from "../../entities/CalculationLine";
import { RootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import AngleBgManager from "../AngleBgManager";
import { generateRotationAngles } from "./helpers/drawRotationHelpers";

export default class AnimationManager {
  private RootEventBus = RootEventBus;

  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private AngleBgManager: AngleBgManager,
    private LineManager: LineManager,
    private SliderManager: SliderManager,
    private circle: Circle,
    private calcLine: CalculationLine,
  ) {
    generateRotationAngles(this.PointManager, 0);
    this.AngleManager.draw(PointManager.getPoints(), false);
    this.calcLine.visible = false;
  }

  completedIntroAnim = () => {
    this.RootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
    this.RootEventBus.emit(EnumRootEventBus.completedIntroAnim)
  }
  runAnimations = () => runIntroAnimation(this, () => this.completedIntroAnim());
}
